export const WEBSEARCH_BOX_EN = {
  // Web Search translations
  searchBoxTitle: 'Web Search',
  searchPlaceholder: 'Enter your search query...',
  searchButton: 'Search',
  searchTypeNormal: 'Search',
  searchTypeEnhanced: 'Enhanced Search',
  searchTypeNormalDescription: 'Search the web like in Google',
  searchTypeEnhancedDescription: 'Use the enhanced Newsrooms search',
  searchTypeLabel: 'Search type',
  searchResults: 'Search Results',
  resultsFound: 'results found',
  searchCompletedIn: 'Search completed in',
  noResultsFound: 'No results found for your search query.',
  searchError: 'Please enter a search query',
  searchFailed: 'Failed to perform search',
  enhancedSearchFailed: 'Failed to perform enhanced search',
  searchCompleted: 'Search completed successfully',
  enhancedSearchCompleted: 'Enhanced search completed successfully',
  usingStandardSearch: 'Search the web like in Google',
  usingEnhancedSearch: 'Use the enhanced Newsrooms search',
  enhancedRecommended: 'Recommended',
  allResults: 'All Results',
  reasoning: 'Reasoning:',
  noSearchResultsYet: 'No search results yet',
  searchWebDescription:
    'Search the web similar to Google search. Add results to your Cooking Pot and generate your content.',
  tryDifferentSearch: 'Try a different search term or refine your query.',
  addSearchResultsTo: 'Add selected search results to',
  addTargetEditor: 'Editor',
  addTargetResearchBrainstorm: 'Research Brainstorm',
  addTargetPlanApproach: 'Plan Approach',
  researchBrainstormPresetPrefix: 'Research brainstorm context:',
  planApproachPresetPrefix: 'Plan approach context:',
  addedToResearchDraft: 'Added to research input draft',

  // Scraper translations
  scraperBoxTitle: 'URL Upload', // Changed from 'Web Scraper'
  scraperPlaceholder: 'Enter URL to scrape...',
  scraperButton: 'Scrape',
  scraperError: 'Please enter a URL',
  invalidUrl: 'Please enter a valid URL',
  scrapeCompleted: 'Content scraped successfully',
  scrapeFailed: 'Failed to scrape content',
  scrapedContent: 'Scraped Content',
  useContent: 'Use Content',
  enterUrlToScrape: 'Enter a URL above to scrape its content',
  scraperDescription: 'Extract content from any webpage by entering its URL',
  webSearchScraping: 'Looking up content...',
  noScraperResults: 'No content found',
  readyToScrape: 'Ready to scrape',
  tryDifferentUrl: 'Try a different URL or check if the site is accessible.',
  scrapingContent: 'Scraping content...', // Standardized value
  scraperTextView: 'Text View',
  scraperWebsiteView: 'Website View',
  scraperNoTitle: 'No title', // Changed from 'No title available'
  scraperNoContent: 'No content available',
  urlSubmitted: 'URL submitted successfully', // Added

  // Batch scraping
  batchScrapePlaceholder: 'Enter URLs (one per line)...',
  batchScrapeButton: 'Scrape All',
  scrapingBatch: 'Scraping multiple URLs...',
  batchResults: 'Batch Results',
  failedToScrape: 'Failed to scrape',
  successfullyScrapped: 'Successfully scraped',

  // Preview
  textView: 'Text View',
  websiteView: 'Website View',
  websiteViewError: 'Unable to load website',
  iframeTooltip:
    "Some websites block iframe embedding for security reasons. If the website view doesn't load, use the text view to see the content."
} as const

export const WEBSEARCH_BOX_DE = {
  // Web Search translations
  searchBoxTitle: 'Web Suche',
  searchPlaceholder: 'Geben Sie Ihre Suchanfrage ein...',
  searchButton: 'Suchen',
  searchTypeNormal: 'Standard Suche',
  searchTypeEnhanced: 'Erweiterte Suche',
  searchTypeNormalDescription: 'Das Web durchsuchen wie bei Google',
  searchTypeEnhancedDescription: 'Die erweiterte Newsrooms-Suche verwenden',
  searchTypeLabel: 'Such Art',
  searchResults: 'Suchergebnisse',
  resultsFound: 'Ergebnisse gefunden',
  searchCompletedIn: 'Suche abgeschlossen in',
  noResultsFound: 'Keine Ergebnisse für Ihre Suchanfrage gefunden.',
  searchError: 'Bitte geben Sie eine Suchanfrage ein',
  searchFailed: 'Suche fehlgeschlagen',
  enhancedSearchFailed: 'Erweiterte Suche fehlgeschlagen',
  searchCompleted: 'Suche erfolgreich abgeschlossen',
  enhancedSearchCompleted: 'Erweiterte Suche erfolgreich abgeschlossen',
  usingStandardSearch: 'Das Web durchsuchen wie bei Google',
  usingEnhancedSearch: 'Die erweiterte Newsrooms-Suche verwenden',
  enhancedRecommended: 'Empfohlen',
  allResults: 'Alle Ergebnisse',
  reasoning: 'Begründung:',
  noSearchResultsYet: 'Noch keine Suchergebnisse',
  searchWebDescription:
    'Durchsuchen Sie das Web ähnlich wie bei Google. Fügen Sie Ergebnisse zu Ihrem Cooking Pot hinzu und generieren Sie Ihre Inhalte.',
  tryDifferentSearch: 'Versuchen Sie einen anderen Suchbegriff oder verfeinern Sie Ihre Anfrage.',
  addSearchResultsTo: 'Ausgewählte Suchergebnisse hinzufügen zu',
  addTargetEditor: 'Editor',
  addTargetResearchBrainstorm: 'Recherche-Brainstorming',
  addTargetPlanApproach: 'Vorgehensplan',
  researchBrainstormPresetPrefix: 'Kontext für Recherche-Brainstorming:',
  planApproachPresetPrefix: 'Kontext für Vorgehensplan:',
  addedToResearchDraft: 'Zum Recherche-Eingabeentwurf hinzugefügt',

  // Scraper translations
  scraperBoxTitle: 'URL Upload', // Changed from 'Web Scraper'
  scraperPlaceholder: 'URL zum Scrapen eingeben...',
  scraperButton: 'Scrapen',
  scraperError: 'Bitte geben Sie eine URL ein',
  invalidUrl: 'Bitte geben Sie eine gültige URL ein',
  scrapeCompleted: 'Inhalt erfolgreich gescrapt',
  scrapeFailed: 'Scraping fehlgeschlagen',
  scrapedContent: 'Gescrapter Inhalt',
  useContent: 'Inhalt verwenden',
  enterUrlToScrape: 'Geben Sie oben eine URL ein, um deren Inhalt zu scrapen',
  scraperDescription: 'Extrahieren Sie Inhalte von jeder Webseite durch Eingabe ihrer URL',
  webSearchScraping: 'Inhalte werden abgerufen...',
  noScraperResults: 'Kein Inhalt gefunden',
  readyToScrape: 'Bereit zum Scrapen',
  tryDifferentUrl: 'Versuchen Sie eine andere URL oder prüfen Sie, ob die Seite erreichbar ist.',
  scrapingContent: 'Inhalt wird gescrapt...', // Standardized value
  scraperTextView: 'Textansicht',
  scraperWebsiteView: 'Webseitenansicht',
  scraperNoTitle: 'Kein Titel', // Changed from 'Kein Titel verfügbar'
  scraperNoContent: 'Kein Inhalt verfügbar',
  urlSubmitted: 'URL erfolgreich gesendet', // Added

  // Batch scraping
  batchScrapePlaceholder: 'URLs eingeben (eine pro Zeile)...',
  batchScrapeButton: 'Alle scrapen',
  scrapingBatch: 'Mehrere URLs werden gescrapt...',
  batchResults: 'Batch-Ergebnisse',
  failedToScrape: 'Scraping fehlgeschlagen',
  successfullyScrapped: 'Erfolgreich gescrapt',

  // Preview
  textView: 'Textansicht',
  websiteView: 'Webseitenansicht',
  websiteViewError: 'Webseite kann nicht geladen werden',
  iframeTooltip:
    'Einige Websites blockieren die Iframe-Einbettung aus Sicherheitsgründen. Wenn die Webseitenansicht nicht lädt, verwenden Sie die Textansicht, um den Inhalt zu sehen.'
} as const
